import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import API_URLS from "../../Utils/axr";
import store from "../store";
import { errorConditionGTM } from "../../Utils/googleTags";
import { fetchAppointmentDetailsTimeslots } from "../../../../shared/hooks/useFetchAppointment";

type confirmAvailableSlotState = {
  confirmAvailableSlotData: any;
  loading: boolean;
  error: any;
};

const initialState: confirmAvailableSlotState = {
  confirmAvailableSlotData: null,
  loading: false,
  error: null,
};

export const confirmAvailableSlot = createAsyncThunk(
  "appointment/confirmAvailableSlot",
  async ( dateValues: any , { rejectWithValue }) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const wirecenter = reduxStore?.addressQualification?.data?.addressQualification?.entity?.wireCenter;
      const inquiryReservationNumber = reduxStore?.appointmentTimeslotData?.appointmentTimeslotData?.schedulingResponse?.inquiryReservationNumber;
      const partnerSessionId = reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId
      let url=API_URLS["confirmAvailableSlot"]

      const payload = {
        baseline: {
          transactionId: partnerSessionId,
          partnerId: "",
          salesCode: "",
          partnerReferenceId: "",
          agentId: "",
          channel: "ContactCenter",
          siteId: "bs",
          wirecenter: wirecenter || "",
          intent: "dsl_migration",
          workflow: "migratecoppertofiber",
          billingType: "postpaid"
        },
        inquiryReservationNumber: inquiryReservationNumber || "",
        selectedAppointment: {
          appointmentDate: dateValues?.appointmentDate,
          appointmentTime: {
            appointmentAfterTime: dateValues?.appointmentAfterTime,
            appointmentBeforeTime: dateValues?.appointmentBeforeTime,
            appointmentCompleteTime: dateValues?.appointmentCompleteTime
          }
        },
        "installType": "Schedule"
      }
      const params = { "": url };

      const response = await fetchAppointmentDetailsTimeslots(
        params,
        payload,
        headers
      );

      return response?.data;
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        "Something went wrong while confirming available slot";

      return rejectWithValue(errorMessage);
    }
  }
);


const confirmAvailableSlotSlice = createSlice({
  name: "confirmAvailableSlot",
  initialState,
  reducers: {
    clearconfirmAvailableSlotSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(confirmAvailableSlot.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      confirmAvailableSlot.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.confirmAvailableSlotData = action.payload;
        state.error = null;
      }
    );
    builder.addCase(confirmAvailableSlot.rejected, (state, action) => {
      state.loading = false;
      state.confirmAvailableSlotData = null;
      state.error = action.payload ?? action.error?.message;

      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "check available slot",
        action.error?.message,
        action?.type
      );
    });
  },
});

export const { clearconfirmAvailableSlotSlice } =
  confirmAvailableSlotSlice.actions;

export default confirmAvailableSlotSlice.reducer;